import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function NoAccess() {
  const { t } = useI18n();
  const nav = useNavigate();
  return (
    <div className="fade-in w-full min-h-[60vh] flex items-center justify-center" data-testid="no-access-page">
      <div className="max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/25 flex items-center justify-center mx-auto mb-5">
          <ShieldAlert className="w-8 h-8 text-amber-400" />
        </div>
        <h1 className="text-2xl font-black tracking-tight mb-2">{t("Kein Zugriff auf diesen Bereich")}</h1>
        <p className="text-sm text-gray-400 mb-7">{t("Sie haben für diesen Bereich aktuell keine Berechtigung. Bitte wenden Sie sich an den Super Admin, falls Sie Zugriff benötigen.")}</p>
        <button onClick={() => nav("/admin")} data-testid="no-access-back" className="bg-[#A3E635] hover:bg-[#b6f15a] text-black font-bold py-2.5 px-5 rounded-lg text-sm inline-flex items-center gap-2 transition-colors">
          <ArrowLeft className="w-4 h-4" /> {t("Zurück zum Dashboard")}
        </button>
      </div>
    </div>
  );
}
